<template>
    <div>
    <a-modal
        :visible="true"
        :width="900"
        :footer="null"
        :closable="false"
        :destroy-on-close="true"
        centered
        wrap-class-name="tpm-wrap"
        @cancel="$emit('close')"
    >
        <div class="tpm-modal">
            <div class="tpm-head">
                <div>
                    <h3>Adicionar novo produto</h3>
                    <div class="tpm-sub">{{ providerName }}<template v-if="sellerName"> · {{ sellerName }}</template></div>
                </div>
                <a-tooltip title="Fechar">
                    <a-button class="tpm-x" @click="$emit('close')">
                        <span class="material-icons-outlined">close</span>
                    </a-button>
                </a-tooltip>
            </div>

            <div class="apm-tools">
                <a-input-group compact class="apm-search-group">
                    <a-select
                        v-model="searchField"
                        class="apm-search-group-field"
                        allow-clear
                        placeholder="Buscar por"
                        :dropdown-style="{ minWidth: '160px' }"
                    >
                        <a-select-option v-for="option in searchFieldOptions" :key="option.key" :value="option.key">
                            {{ option.label }}
                        </a-select-option>
                    </a-select>
                    <a-input
                        v-model="search"
                        placeholder="Buscar"
                        allow-clear
                        class="apm-search-group-input"
                        :disabled="!searchField"
                        @pressEnter="filtrar"
                    />
                </a-input-group>

                <a-select
                    v-model="category"
                    class="apm-category-select"
                    placeholder="Categoria"
                    allow-clear
                    show-search
                    option-filter-prop="children"
                >
                    <a-select-option v-for="option in categories" :key="option.cat_id" :value="option.cat_id">
                        {{ option.cat_descricao }}
                    </a-select-option>
                </a-select>

                <a-button type="primary" @click="filtrar">Filtrar</a-button>
            </div>

            <div class="tpm-body">
                <a-table
                    size="small"
                    :columns="columns"
                    :data-source="rows"
                    :loading="loading"
                    :pagination="pagination"
                    row-key="pro_id"
                    :locale="{ emptyText: 'Nenhum produto encontrado.' }"
                    @change="handleTableChange"
                >
                    <template slot="nome" slot-scope="text, product">
                        <div class="tpm-pname">{{ product.pro_descricao }}</div>
                        <div class="tpm-pean" v-if="product.pro_ean">EAN {{ product.pro_ean }}</div>
                    </template>

                    <template slot="embalagem" slot-scope="text, product">{{ product.pro_embalagem || "—" }}</template>

                    <template slot="codinterno" slot-scope="text, product">{{ product.pro_codInterno || "—" }}</template>

                    <template slot="acoes" slot-scope="text, product">
                        <a-button class="tpm-btn" :disabled="loadingBrands" @click="chooseProduct(product)">Adicionar</a-button>
                    </template>
                </a-table>
            </div>

            <div class="tpm-foot">
                <a-button class="tpm-btn-ghost" @click="$emit('close')">Fechar</a-button>
            </div>
        </div>
    </a-modal>

    <a-modal
        :visible="brandPicker.open"
        :width="500"
        title="Selecione a marca"
        :footer="null"
        @cancel="brandPicker.open = false"
    >
        <div class="apm-brand-sub">{{ brandPicker.product && brandPicker.product.pro_descricao }}</div>
        <ul class="apm-brand-list">
            <li v-for="brand in brandPicker.brands" :key="brand.pro_id" class="apm-brand-item">
                <span>{{ brand.pro_observacao || brand.pro_descricao }}</span>
                <a-button class="tpm-btn" @click="selectBrand(brand)">Selecionar</a-button>
            </li>
        </ul>
    </a-modal>
    </div>
</template>

<script>
import QuotationService from "@/services/QuotationService";
import ProductService from "@/services/ProductService";
import ErrorHandlerService from "@/services/ErrorHandlerService";

export default {
    name: "AddProductPickerModal",
    props: {
        quotationId: [String, Number],
        providerName: String,
        sellerName: String,
        excludeIds: { type: Array, default: () => [] },
    },
    data() {
        return {
            svc: new QuotationService(),
            product_svc: new ProductService(),
            rows: [],
            categories: [],
            loading: false,
            loadingBrands: false,
            brandPicker: { open: false, product: null, brands: [] },
            search: "",
            searchField: "name",
            category: undefined,
            searchFieldOptions: [
                { key: "name", label: "Descrição" },
                { key: "ean", label: "EAN" },
                { key: "code", label: "Código interno" },
            ],
            pagination: {
                current: 1,
                pageSize: 20,
                total: 0,
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
            },
        };
    },
    computed: {
        columns() {
            return [
                { title: "Produto", key: "nome", scopedSlots: { customRender: "nome" } },
                { title: "Embalagem", key: "embalagem", align: "center", width: 120, scopedSlots: { customRender: "embalagem" } },
                { title: "Código interno", key: "codinterno", align: "center", width: 130, scopedSlots: { customRender: "codinterno" } },
                { title: "Ações", key: "acoes", width: 120, scopedSlots: { customRender: "acoes" } },
            ];
        },
    },
    created() {
        this.load(1);
    },
    methods: {
        filtrar() {
            this.load(1);
        },
        buildParams(page) {
            const params = {
                page,
                items_by_page_value: this.pagination.pageSize,
                deleted: 0,
                categoria: this.category || null,
            };

            if (this.searchField === "code") {
                params.codigoInterno = this.search;
            } else if (this.searchField === "ean") {
                params.pro_eans = this.search ? [this.search] : null;
            } else {
                params.nomeproduto = this.search;
            }

            return params;
        },
        load(page = 1) {
            this.loading = true;

            this.svc
                .getProdutosClientePorPagina(this.buildParams(page))
                .then((response) => response.data)
                .then((data) => {
                    const items = data.produtos.data || [];
                    const excluded = this.excludeIds.map(String);

                    this.rows = items.filter((row) => !excluded.includes(String(row.pro_id)));
                    this.pagination.total = data.produtos.total;
                    this.pagination.current = data.produtos.current_page;
                    this.pagination.pageSize = data.produtos.per_page || items.length || this.pagination.pageSize;

                    this.categories = (data.categorias || []).filter(
                        (c) => c.cat_excluido != "1" && c.cat_status != "0"
                    );
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleTableChange(pagination) {
            this.pagination.pageSize = pagination.pageSize;
            this.load(pagination.current);
        },
        chooseProduct(product) {
            if (!product.pro_generico) {
                this.$emit("select", product);
                return;
            }

            // Produto genérico: a oferta tem que ser gravada numa marca filha
            // (pro_principal apontando pra esse produto), nunca no próprio
            // genérico — senão o comparativo nunca acha a oferta.
            this.loadingBrands = true;

            this.product_svc
                .get_product_brands(product.pro_id)
                .then((response) => response.data)
                .then((brands) => {
                    const list = (brands || []).filter((b) => b.pro_status == "1");

                    if (!list.length) {
                        this.$message.error(
                            "Esse produto genérico ainda não tem nenhuma marca cadastrada. Cadastre uma marca antes de adicionar."
                        );
                        return;
                    }

                    if (list.length === 1) {
                        this.emitBrand(product, list[0]);
                        return;
                    }

                    this.brandPicker = { open: true, product, brands: list };
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.loadingBrands = false;
                });
        },
        selectBrand(brand) {
            this.emitBrand(this.brandPicker.product, brand);
        },
        emitBrand(product, brand) {
            this.brandPicker.open = false;

            this.$emit("select", {
                ...product,
                pro_id: brand.pro_id,
                pro_observacao: brand.pro_observacao,
                pro_ean: brand.pro_ean || product.pro_ean,
                pro_codInterno: brand.pro_codInterno || product.pro_codInterno,
                pro_embalagem: brand.pro_embalagem || product.pro_embalagem,
                pro_generico: 0,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.apm-brand-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-bottom: 12px;
}
.apm-brand-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.apm-brand-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
}
.tpm-modal {
    max-height: 88vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.tpm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
    }
}
.tpm-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.tpm-x.ant-btn,
.tpm-x.ant-btn:focus,
.tpm-x.ant-btn:active {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
.tpm-x.ant-btn:hover {
    background: #f0f0f0;
    color: #262626;
}
.apm-tools {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0 20px 12px;
}
.apm-search-group {
    display: flex !important;
    flex: 1 1 240px;
    min-width: 220px;
    max-width: 340px;
}
.apm-search-group-field {
    width: 130px;
    flex: 0 0 auto;
}
.apm-search-group-input {
    flex: 1;
    min-width: 0;
}
.apm-category-select {
    width: 220px;
}
.tpm-body {
    flex: 1;
    overflow-y: auto;
    padding: 4px 20px;
    border-top: 1px solid #f0f0f0;
    min-height: 200px;
}
.tpm-pname {
    font-weight: 600;
    font-size: 13px;
    color: #262626;
}
.tpm-pean {
    font-size: 11px;
    color: #8c8c8c;
}
.tpm-btn.ant-btn,
.tpm-btn.ant-btn:hover,
.tpm-btn.ant-btn:focus,
.tpm-btn.ant-btn:active {
    height: 28px;
    padding: 0 12px;
    border: 1px solid var(--primary-color);
    background: var(--primary-color-opacity, rgba(232, 96, 44, 0.08));
    color: var(--primary-color);
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    box-shadow: none;
}
.tpm-btn.ant-btn[disabled],
.tpm-btn.ant-btn[disabled]:hover {
    opacity: 0.5;
    cursor: not-allowed;
}
.tpm-foot {
    display: flex;
    justify-content: flex-end;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
.tpm-btn-ghost.ant-btn,
.tpm-btn-ghost.ant-btn:focus,
.tpm-btn-ghost.ant-btn:active {
    height: 38px;
    padding: 0 18px;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #434343;
    font-weight: 500;
    font-size: 14px;
    box-shadow: none;
}
.tpm-btn-ghost.ant-btn:hover {
    border-color: var(--primary-color);
    color: var(--primary-color);
}
</style>
